import { render, staticRenderFns } from "./playback-transcript.vue?vue&type=template&id=3807e328"
import script from "./playback-transcript.vue?vue&type=script&lang=js"
export * from "./playback-transcript.vue?vue&type=script&lang=js"
import style0 from "./playback-transcript.vue?vue&type=style&index=0&id=3807e328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports